import { useParams, Navigate } from 'react-router-dom';
import ServicePageLayout from './components/ServicePageLayout';
import { SERVICES_DATA, RELATED_SERVICES_MAP } from './data/servicesData';

interface ServicePageProps {
  lang: 'en' | 'tr';
}

export default function ServicePage({ lang }: ServicePageProps) {
  const { slug } = useParams<{ slug: string }>();
  const service = SERVICES_DATA.find((s) => s.slug === slug);

  if (!service) {
    return <Navigate to={lang === 'tr' ? '/tr' : '/'} replace />;
  }

  const relatedSlugs = RELATED_SERVICES_MAP[service.slug] ?? [];
  const relatedServices = relatedSlugs
    .map((s) => SERVICES_DATA.find((d) => d.slug === s))
    .filter(Boolean)
    .map((d) => ({
      slug: d!.slug,
      title: lang === 'tr' ? d!.tr.title : d!.en.title,
      icon: d!.icon,
    }));

  const data = lang === 'tr' ? service.tr : service.en;

  return (
    <ServicePageLayout
      lang={lang}
      slug={service.slug}
      icon={service.icon}
      heroImage={service.heroImage}
      title={data.title}
      subtitle={data.subtitle}
      description={data.description}
      longDescription={data.longDescription}
      features={data.features}
      faq={data.faq}
      relatedServices={relatedServices}
      seo={data.seo}
    />
  );
}
